/**
 * «Юниверситет» (28.09): ачивки по условиям when из пакета. Полученная не пропадает
 * (хранится в прогрессе ach). Ачивки с manual пока закрыты — режима наставника нет (ТЗ).
 */
import type { UniPack, UniProgress } from "@ub/shared/uni";
import css from "./uni.module.css";

export function Achievements({ pack, prog, earned }: { pack: UniPack; prog: UniProgress; earned: string[] }) {
  const got = new Set([...Object.keys(prog.ach), ...earned]);
  const list = pack.achievements;
  const n = list.filter((a) => got.has(a.id)).length;
  return (
    <section className={css.card} aria-labelledby="uni-ach-h" data-fb="achs" data-fb-name="Ачивки">
      <h3 className={css.h} id="uni-ach-h">Ачивки <b>{n} / {list.length}</b></h3>
      <ul className={css.ach}>
        {list.map((a) => {
          const on = got.has(a.id);
          return (
            <li key={a.id} className={on ? css.achGot : ""} data-fb={`ach:${a.id}`} data-fb-name={`Ачивка «${a.title}»`}>
              {/* цифры — --f-num, не Orbitron (правило репо: у него 5≈6) */}
              <i className={/^\d+$/.test(a.sign) ? css.achNum : ""} aria-hidden="true">{a.sign}</i>
              {a.title}
              <span className={css.sr}>{on ? " — получена" : " — пока закрыта"}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
